/* content file: replace all html between <> </> with actual content */

export const Awards = () => { 
  return (
  <>
    <p>
      Die bisherigen Auszeichnungen von GA-Lotse sind eine besondere Anerkennung unserer Arbeit. Sie würdigen die Innovationskraft und Praxisnähe der Software und zeigen, dass unser Ansatz einer offenen, nutzerorientierten Digitalisierung auch über das Gesundheitsamt Frankfurt hinaus überzeugt.</p>
  </>    
  )
}